import { Component, ComponentInterface, Prop } from '@stencil/core';

@Component({
	tag: 'ds-text-card',
})
export class TextCard implements ComponentInterface {
	@Prop() iconStyle: 'none' | 'small' | 'large' = 'none';
}
